import { useMemo } from 'react';

import type { DomainQueryOptions } from '@/domain/shared/types';
import { useLocationDepthSeriesController_getLocationDepthSeries } from '@/services/hooks';
import type { DepthSeriesResponseDto } from '@/services/types';

import { mapDepthSeriesToDomain } from './mappers';
import type { DepthSeries, DepthSeriesParams, UseGetDepthSeriesResult } from './types';

const EMPTY: DepthSeries = { cages: [] };

export function useGetLocationDepthSeries(
    clientId: number,
    locationId: number,
    params: DepthSeriesParams,
    options?: DomainQueryOptions<DepthSeriesResponseDto>
): UseGetDepthSeriesResult {
    const query = useLocationDepthSeriesController_getLocationDepthSeries(
        clientId,
        locationId,
        params,
        options
    );
    const data = useMemo(() => mapDepthSeriesToDomain(query.data?.data), [query.data?.data]);

    return {
        ...query,
        isLoading: query.isPending,
        data: query.data?.data ? data : EMPTY,
    };
}
